import { useSelector, useDispatch } from 'react-redux';
import Tooltip from '@mui/material/Tooltip';

import { useEffect, useState } from "react";

// react-router-dom components
import { useLocation, NavLink } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";

// Argon Dashboard 2 MUI components
import ArgonBox from "../ArgonBox";
import ArgonTypography from "../ArgonTypography";

// Argon Dashboard 2 MUI example components
import SidenavItem from "../Sidenav/SidenavItem";
import SidenavFooter from "../Sidenav/SidenavFooter";
import MenuOpenIcon from '@mui/icons-material/MenuOpen';

// Custom styles for the Sidenav
import SidenavRoot from "../Sidenav/SidenavRoot";
import sidenavLogoLabel from "../Sidenav/styles/sidenav";
import { setMiniSidenav } from '../../../slices/page.slice';

import TreeView from '@mui/lab/TreeView';
import TreeItem, { treeItemClasses } from '@mui/lab/TreeItem';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import uuid4 from "uuid4";

// Argon Dashboard 2 MUI context
//import { useArgonController, setMiniSidenav } from "context";

const StyledTreeItemRoot = styled(TreeItem)(({ theme }) => ({
  color: theme.palette.text.secondary,
  [`& .${treeItemClasses.content}`]: {
    color: theme.palette.text.secondary,
    borderTopRightRadius: theme.spacing(2),
    borderBottomRightRadius: theme.spacing(2),
    paddingRight: theme.spacing(1),
    //fontWeight: theme.typography.fontWeightMedium,
    '&.Mui-expanded': {
      //fontWeight: theme.typography.fontWeightRegular,
    },
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    '&.Mui-focused, &.Mui-selected': {
      //backgroundColor: `var(--tree-view-bg-color, ${theme.palette.action.selected})`,
      color: 'var(--tree-view-color)',
    },
    [`& .${treeItemClasses.label}`]: {
      fontWeight: 'inherit',
      color: 'inherit',
    },
  },
  [`& .${treeItemClasses.group}`]: {
    marginLeft: 0,
    [`& .${treeItemClasses.content}`]: {
      paddingLeft: theme.spacing(2),
    },
  },
}));

function StyledTreeItem(props) {
  const {
    bgColor,
    color,
    labelIcon: LabelIcon,
    labelInfo,
    labelText,
    ...other
  } = props;

  return (
    <StyledTreeItemRoot
      label={
        <Box sx={{ display: 'flex', alignItems: 'center', p: 0.5, pr: 0 }}>
          {LabelIcon}
          <Typography variant="body2" sx={{ fontWeight: 'inherit', flexGrow: 1 }}>
            {labelText}
          </Typography>
          <Typography variant="caption" color="inherit">
            {labelInfo}
          </Typography>
        </Box>
      }
      style={{
        '--tree-view-color': color,
        //'--tree-view-bg-color': bgColor,
      }}
      {...other}
    />
  );
}

StyledTreeItem.propTypes = {
  bgColor: PropTypes.string,
  color: PropTypes.string,
  labelIcon: PropTypes.elementType.isRequired,
  labelInfo: PropTypes.string,
  labelText: PropTypes.string.isRequired,
};

function Sidenav({ color, brand, brandMini, brandName, routes, ...rest }) {
  //const [controller, dispatch] = useArgonController();
  const page = useSelector(x => x.page);
  const miniSidenav  = page.miniSidenav;
  const darkSidenav  = page.darkSidenav;
  const layout  = page.layout;
  const dispatch = useDispatch();

  const location = useLocation();
  const { pathname } = location;
  const itemName = pathname.split("/").slice(1)[0];

  const authUser = JSON.parse(localStorage.getItem('user'))

  const closeSidenav = () => dispatch(setMiniSidenav(true));

  useEffect(() => {
    // A function that sets the mini state of the sidenav.
    function handleMiniSidenav() {
      dispatch(setMiniSidenav(window.innerWidth < 1200));
    }

    /** 
     The event listener that's calling the handleMiniSidenav function when resizing the window.
    */
    window.addEventListener("resize", handleMiniSidenav);

    // Call the handleMiniSidenav function to set the state with the initial value.
    handleMiniSidenav();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleMiniSidenav);
  }, [dispatch, location]);

  var nodeId = 0;
  var expandedNodIds = [];
  // Render all the routes from the routes.js (All the visible items on the Sidenav)
  console.log(routes);
  const renderRoutesNestedTest = routes.filter(it => ((authUser.role === "CustomerPortal") || (authUser.role === "FinancialPersonnel") || (authUser.role !== "CustomerPortal" && authUser.role !== "FinancialPersonnel" && !it.isFinancial) ) && it.type === "FirtLevelMainMenuItem").map(({ type, name, icon, title, key, href, route, path, level }) => {
    console.log("piggyBack");
    nodeId++;
    let returnValueItems = [];
      routes.filter(yu => ((authUser.role === "CustomerPortal") || (authUser.role === "FinancialPersonnel") || (authUser.role !== "CustomerPortal" && authUser.role !== "FinancialPersonnel" && !yu.isFinancial) ) && yu.type === "SecondLevelMainMenuItem" && yu.level.startsWith(level + "-")).map(({ type, name, icon, title, key, href, route, path, level }) => {
        //console.log("nkey" + key);
        returnValueItems.push(miniSidenav ? <Tooltip placement="left" title={title}><Link className='menuItem' href={path} key={uuid4()} rel="noreferrer"><StyledTreeItem nodeId={nodeId} className={key.toLowerCase() === itemName.toLowerCase() ? 'selectedMenuItem' : 'menuItem'} labelText={miniSidenav ? "" : title} labelIcon={icon} /></Link></Tooltip> : <Link className='menuItem' href={path} key={uuid4()} rel="noreferrer"><StyledTreeItem nodeId={nodeId} className={key.toLowerCase() === itemName.toLowerCase() ? 'selectedMenuItem' : 'menuItem'} labelText={miniSidenav ? "" : title} labelIcon={icon} /></Link>);
        
        nodeId++;
    });
    //console.log(level);
    if(returnValueItems.length > 0){
      if(key.toLowerCase() === itemName.toLowerCase()){
        expandedNodIds.push(nodeId.toString());
      }
      return miniSidenav ? <Tooltip placement="left" title={title}><StyledTreeItem nodeId={nodeId} key={uuid4()} className={key.toLowerCase() === itemName.toLowerCase() ? 'selectedMenuItem' : 'menuItem'} labelText={miniSidenav ? "" : title} labelIcon={icon} >
                {returnValueItems}
              </StyledTreeItem></Tooltip> : <StyledTreeItem nodeId={nodeId} key={uuid4()} className={key.toLowerCase() === itemName.toLowerCase() ? 'selectedMenuItem' : 'menuItem'} labelText={miniSidenav ? "" : title} labelIcon={icon} >
                {returnValueItems}
              </StyledTreeItem>
    }else{
      return miniSidenav ?  <Tooltip placement="left" title={title}><Link href={path} key={uuid4()} rel="noreferrer">
              <StyledTreeItem nodeId={nodeId} className={key.toLowerCase() === itemName.toLowerCase() ? 'selectedMenuItem' : 'menuItem'} labelText={miniSidenav ? "" : title} labelIcon={icon} ></StyledTreeItem>
             </Link></Tooltip> : <Link href={path} key={uuid4()} rel="noreferrer">
              <StyledTreeItem nodeId={nodeId} className={key.toLowerCase() === itemName.toLowerCase() ? 'selectedMenuItem' : 'menuItem'} labelText={miniSidenav ? "" : title} labelIcon={icon} ></StyledTreeItem>
             </Link>
    }
    
  });

  {/*
  const renderRoutesNested1 = routes.filter(it =>  it.type === "MainMenuItem").map(({ type, name, icon, title, key, href, route, path, level }) => {
    //console.log(level);
    return <Link href={path} key={key} rel="noreferrer">
            <StyledTreeItem nodeId="1" className={key.toLowerCase() === itemName.toLowerCase() ? 'selectedMenuItem' : 'menuItem'} labelText={title} labelIcon={icon} />
           </Link>
  });
  const renderRoutes = routes.filter(it =>  it.type === "MainMenuItem").map(({ type, name, icon, title, key, href, route, path }) => {
    return <NavLink to={path} key={key}>
            <SidenavItem
              name={title}
              icon={icon}
              active={key.toLowerCase() === itemName.toLowerCase()}
              //noCollapse={noCollapse}
            />
           </NavLink>
  });

  const renderRoutes2 = routes.map(({ type, name, icon, title, key, href, route, path }) => {

    //console.log(title);
    let returnValue;
    if (type === "title") {
      returnValue = (
        <ArgonTypography
          key={key}
          color={darkSidenav ? "white" : "dark"}
          display="block"
          variant="caption"
          fontWeight="bold"
          textTransform="uppercase"
          opacity={0.6}
          pl={3}
          mt={2}
          mb={1}
          ml={1}
        >
          {title}
        </ArgonTypography>
      );
    } else if (type === "divider") {
      returnValue = <Divider key={key} light={darkSidenav} />;
    }

    return returnValue;
  });
  */}
  console.log("EXPAAAAAAAAAAANED");

  console.log(expandedNodIds);

  return (
    <SidenavRoot {...rest} variant="permanent" ownerState={{ darkSidenav, miniSidenav, layout }}>
      <ArgonBox pt={3} pb={1} px={4} textAlign="center" className="sideNavLogoMMG">
        <ArgonBox
          display={{ xs: "block", xl: "none" }}
          position="absolute"
          top={0}
          right={0}
          p={1.625}
          onClick={closeSidenav}
          sx={{ cursor: "pointer" }}
        >
          <ArgonTypography variant="h6" color="secondary">
          <MenuOpenIcon />
           {/* <Icon sx={{ fontWeight: "bold" }}>close</Icon> */}
          </ArgonTypography>
        </ArgonBox>
           <img src={miniSidenav ? brandMini : brand} />
           <br/>
          <ArgonBox sx={(theme) => sidenavLogoLabel(theme, { miniSidenav })}>
            <ArgonTypography
              component="h6"
              variant="button"
              fontWeight="medium"
              color={darkSidenav ? "white" : "dark"}>
              {brandName}
            </ArgonTypography>
          </ArgonBox>
      </ArgonBox>
      <Divider light={darkSidenav} />
    <TreeView
      aria-label="gmail"
      defaultExpanded={expandedNodIds}
      //expanded={true}
      defaultCollapseIcon={<ArrowDropDownIcon />}
      defaultExpandIcon={<ArrowLeftIcon />}
      defaultEndIcon={<div style={{ width: 24 }} />}
      sx={{ height: 264, flexGrow: 1, maxWidth: 400, overflowY: 'auto' }}
    >
      {renderRoutesNestedTest}
    </TreeView>
      <ArgonBox pt={1} mt="auto" mb={2} mx={2}>
        <SidenavFooter />
      </ArgonBox>
    </SidenavRoot>
  );
}

// Setting default values for the props of Sidenav
Sidenav.defaultProps = {
  color: "info",
  brand: "",
};

// Typechecking props for the Sidenav
Sidenav.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  brand: PropTypes.string,
  brandName: PropTypes.string.isRequired,
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Sidenav;
